import React from 'react';
//import { DragDropContainer } from 'react-drag-drop-container';
import DragDropContainer  from '../src/DragDropContainer';


/*
    Boxable -- a thing you can drag into a Box
*/

export default class Boxable extends React.Component {
 
  handleDragEnd = (dragData, currentTarget, x, y) => {

  };

    render() {
      
      return (
        <div className="boxable_component" >
          <DragDropContainer

            targetKey={this.props.targetKey}
            dragData={{label: this.props.image}}
            customDragElement={this.props.customDragElement}
            // onDragStart={()=>(console.log('start'))}
            // onDrag={()=>(console.log('dragging'))}
            onDragEnd={this.handleDragEnd}
            // onDrop={(e)=>(console.log(e))}
          >
            {/* <img src={this.props.image} draggable="false"  height="45" style={{ marginLeft: 40, transform:"rotate(75deg)"}}/> */}
            <img src={this.props.image} title={this.props.title} draggable="false" alt="icon" height="100" style={this.props.style}/>
        
          </DragDropContainer>
        </div>
      );
    }
  }